import React, { useRef, useEffect, useState } from 'react';
import reload_icon from "../assets/svg/reload-icon.svg";

const Captcha = ({ onChange }) => {
  const canvasRef = useRef(null);
  const [captchaText, setCaptchaText] = useState('');

  const generateCaptcha = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const chars = "0123456789"; // ✅ Only numbers

    const text = Array.from({ length: 3 }, () =>
      chars[Math.floor(Math.random() * chars.length)]
    ).join("");

    setCaptchaText(text);
    onChange(text);

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.fillStyle = "#f2f5f9";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.font = "28px Arial";
    for (let i = 0; i < text.length; i++) {
      const digit = text[i];
      const angle = (Math.random() - 0.5) * 0.6;
      ctx.save();
      ctx.translate(25 + i * 30, 30);
      ctx.rotate(angle);
      ctx.fillStyle = `rgb(${Math.random() * 150},${Math.random() * 150},${Math.random() * 150})`;
      ctx.fillText(digit, 0, 0);
      ctx.restore();
    }

    // Noise lines
    for (let i = 0; i < 4; i++) {
      ctx.strokeStyle = `rgba(${Math.random() * 255},${Math.random() * 255},${Math.random() * 255},0.7)`;
      ctx.beginPath();
      ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.stroke();
    }
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  return (
    <div className="captcha-box">
      <canvas
        ref={canvasRef}
        width={120}
        height={50}
        className="captcha-img"
      />
      <img
        src={reload_icon}
        onClick={generateCaptcha}
        className="refresh-captcha"
        alt="Refresh captcha"
      />
    </div>
  );
};

export default Captcha;
